import BaseApi from './BaseApi';

/**
 * LINE問い合わせボタン制御設定API。
 */
class UpdateDisplayLineInquiryButtonApi extends BaseApi {
  async update(params: { displayLineInquiryButtonFLG: boolean }) {
    return await this.execute('updateDisplayLineInquiryButtonApi', {
      method: 'POST',
      body: params
    }).then(({ status }) => status === 1);
  }
}

export default UpdateDisplayLineInquiryButtonApi;
